<div *ngIf="navbarSize$ | async as navbarSize">
    <div class="main-container"  [style.height.px]="navbarSize"
        [style]="{background: this.appService.getTheme() === 'light' ? 'var(--p-primary-900)' : 'var(--p-surface-100)'}">
        <div class="content-container" *ngIf="activeEmpNumDetails$ | async as activeEmpNumDetails">
            <div class="row">
                <img src="assets/apaLogo/APA_logo_dark.svg"
                style="width: 30px; height: 30px"/>
                <div class="title">
                    <a class="title-name" href="https://logbook.alliedpilots.org" target="APA Logbook">Logbook</a>
                </div>
            </div>
            <div class="menu">
                <div class="column">
                    <div>{{getUserDisplayName(activeEmpNumDetails)}}</div>
                </div>
                <p-menu #menu [model]="items" [popup]="true" [dt]="menuPanel"
                        [style]="{'width': 'auto'}"
                        >
                    <ng-template pTemplate="start" *ngIf="appService.theme$ | async as theme">
                        <span class="inline-flex align-items-center gap-1 px-2 py-2">
                            @if(theme === 'light') {
                                <img src="assets/apaLogo/APA_logo_light.svg" style="width: 30px; height: 30px"/>
                            }
                            @else {
                                <img src="assets/apaLogo/APA_logo_dark.svg" style="width: 20px; height: 20px"/>
                            }
                            <span class="font-medium text-lg font-semibold" [style]="{'color' : 'var(--text-primary)'}">
                                LOGBOOK
                            </span>
                        </span>
                    </ng-template>
                    <ng-template pTemplate="submenuheader" let-item>
                        <span>{{ item.label }}</span>
                    </ng-template>
                    <ng-template pTemplate="item" let-item>
                        <a pRipple class="flex align-items-center">
                            <span [class]="item.icon"></span>
                            <span class="ml-2" [style]="{'cursor': 'pointer'}">{{ item.label }}</span>
                            <span *ngIf="item.shortcut" class="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">
                                {{ item.shortcut }}
                            </span>
                        </a>
                    </ng-template>
                    <ng-template pTemplate="end">
                        <div pRipple class="name-btn relative overflow-hidden w-full flex align-items-center text-color hover:surface-200 border-noround">
                            <span class="pi pi-user"></span>
                            <span class="inline-flex flex-column ml-2">
                                <span class="font-bold">{{activeEmpNumDetails.nickName ? activeEmpNumDetails.nickName : activeEmpNumDetails.firstName}} {{activeEmpNumDetails.lastName}}</span>
                                <span class="text-sm">{{activeEmpNumDetails.username}}</span>
                            </span>
                        </div>
                    </ng-template>
                </p-menu>
                <p-button [dt]="menuButton" (onClick)="menu.toggle($event)" icon="pi pi-cog"/>
            </div>
        </div>
    </div>
</div>
